const apiBaseUriByHostname: Record<string, string> = {
  'wst-players.dev.srarena.io': 'https://wst.dev.srarena.io',
  'wst-players.staging.srarena.io': 'https://wst.staging.srarena.io',
  'wst-players-sandbox.staging.srarena.io': 'https://wst-sandbox.staging.srarena.io',
};

export function resolveApiBaseUri(hostname: string = window.location.hostname) {
  return apiBaseUriByHostname[hostname] ?? import.meta.env.VITE_API_BASE_URI;
}

export default function getConfig() {
  return {
    appEnv: import.meta.env.MODE,
    apiBaseUri: resolveApiBaseUri(),
  };
}
